import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

function AuthCallback() {
  const [searchParams] = useSearchParams();
  
  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const error = searchParams.get('error');
    const errorDescription = searchParams.get('error_description');

    if (code && state) {
      // Store the authentication data in localStorage
      localStorage.setItem('microsoft_auth_code', code);
      localStorage.setItem('microsoft_auth_state', state);
      localStorage.setItem('microsoft_auth_time', new Date().getTime().toString());
      
      // Redirect back to the main application
      window.location.href = '/';
      
    } else if (error) {
      // Store error information
      localStorage.setItem('microsoft_auth_error', error);
      if (errorDescription) {
        localStorage.setItem('microsoft_auth_error_description', errorDescription);
      }
      
      // Redirect back to the main application
      window.location.href = '/';
    } else {
      // If no code or error, redirect to home
      window.location.href = '/';
    }
  }, [searchParams]);
  
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center p-8 bg-white rounded-lg shadow-md">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
        <h2 className="text-xl font-semibold text-gray-800 mb-2">Completing Microsoft Authentication</h2>
        <p className="text-gray-600">Please wait while we complete your login...</p>
        <p className="text-sm text-gray-500 mt-4">You will be redirected automatically.</p>
      </div>
    </div>
  );
}

export default AuthCallback;